<template>
  <Gallery category="watercolor" />
</template>

<script>
import Gallery from '@/components/Gallery'

export default {
  components: {
    Gallery,
  },
}
</script>

